// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_SalvarMetasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /franquias/salvarMetas/{franquia_id}
 *
 * Partial-update endpoint for franchise financial goals. All fields are
 * optional — the controller only persists keys that were explicitly sent.
 * Several legacy aliases (faturamento_mensal, faturamento_anual, ticket_medio,
 * itens_dia) are mapped onto the canonical DB columns by the controller.
 */
import { registerContract } from './validate'

export interface Franquias_SalvarMetasInput {
investimento_total?: number
roe_desejado?: number
meta_faturamento_mensal?: number
meta_faturamento_anual?: number
crescimento?: number
meta_contatos_retomada_dia?: number
faturamento_mensal?: number
faturamento_anual?: number
ticket_medio?: number
itens_dia?: number
}

registerContract('Franquias_SalvarMetasInput', {
  investimento_total:         { type: 'number',  required: false },
  roe_desejado:               { type: 'number',  required: false },
  meta_faturamento_mensal:    { type: 'number',  required: false },
  meta_faturamento_anual:     { type: 'number',  required: false },
  crescimento:                { type: 'number',  required: false },
  meta_contatos_retomada_dia: { type: 'number',  required: false },
  faturamento_mensal:         { type: 'number',  required: false },
  faturamento_anual:          { type: 'number',  required: false },
  ticket_medio:               { type: 'number',  required: false },
  itens_dia:                  { type: 'number',  required: false },
})
